function initAccordion() {
  document
    .querySelectorAll('.lavendla-accordion__trigger')
    .forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();

        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        const content = document.querySelector(
          '#' + trigger.getAttribute('aria-controls')
        );

        // content.setAttribute('aria-hidden', expanded);
        // trigger.setAttribute('aria-expanded', !expanded);
        maybeExpandElement(content, trigger, expanded);
      });
    });

  function maybeExpandElement(content, trigger, expanded) {
    content.style.height = '';
    content.style.transition = 'none';

    const startHeight = window.getComputedStyle(content).height;

    // Force a layout calculation
    content.setAttribute('aria-hidden', expanded);
    const height = window.getComputedStyle(content).height;

    content.style.height = startHeight;

    requestAnimationFrame(() => {
      content.style.transition = '';

      requestAnimationFrame(() => {
        content.style.height = height;
        trigger.setAttribute('aria-expanded', !expanded);
      });
    });

    content.addEventListener(
      'transitionend',
      () => {
        content.style.height = '';
      },
      {
        once: true,
      }
    );
  }
}

initAccordion();
